import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import { ListarUsuariosAtivosComAcessoCasoController } from "../../../../Controllers/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasController";
import { ListarEtapasController } from "../../../../Controllers/Geral/Etapas/EtapasControllers";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IFiltroAtendimentos } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoInterfaces";
import { ACESSOS } from "../../../../Routes/Acessos";
import SelectComBusca from "../../../../Components/CardsPages/Forms/SelectComBusca";
import { ListarCanalAtendimentoContoller } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IFormData } from "../Atendimentos/useAtendimentosAssistencia";
// import { Switch } from "../../../../Components/CardsPages/Forms/Switch";
// import Swal from "sweetalert2";

interface IFiltroAtendimentoProps {
    handleSubmit: (formData: IFormData) => void;
    FILTRO_ATENDIMENTOS: string | null;
    filter: IFiltroAtendimentos | undefined;
    filtroInicial: {
        DT_INICIO: string;
        DT_FIM: string;
        ID_CASO: number;
        ID_CONTA: number;
        ID_USUARIO_RESPONSAVEL: number;
        DS_STATUS_SOLICITACAO: string;
        DS_CONTA: string;
        DS_CONTATO: string;
        ID_EMPREENDIMENTO: Array<number>;
    };
    setFilter: (filter: IFiltroAtendimentos) => void;
    setPage: (page: number) => void;
    // setNaoContem: Dispatch<SetStateAction<boolean>>;
}

export default function FiltroAtendimento(props: IFiltroAtendimentoProps) {
    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const FormMethods = useForm<IFiltroAtendimentos>();
    const { reset, register } = FormMethods;
    const selectInputRef = useRef<any>();

    const onClear = () => {
        selectInputRef.current?.clearValue();
    };

    const { value: lstEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );

    const { value: lstEtapas } = useAsyncEffect(
        () => ListarEtapasController(ACESSOS.ASSISTENCIA.ID_MODULO ?? 0, 0),
        []
    );

    useEffect(() => {
        setOptions(() =>
            lstEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_EMPREENDIMENTO,
                value: empreendimento.ID_EMPREENDIMENTO,
            }))
        );
    }, [lstEmpreendimentos]);

    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    return (
        <StickyToolbar active={!!props.FILTRO_ATENDIMENTOS}>
            <FormProvider {...FormMethods}>
                <UnForm usingContext handleSubmit={props.handleSubmit}>
                    <div className="col-12 mt-3">
                        <label>Data Início</label>
                        <div className="row">
                            <div className="col-6">
                                <UnForm.Input
                                    className="form-control"
                                    defaultValue={props.filter?.DT_INICIO_IN}
                                    type="date"
                                    name="DT_INICIO_IN"
                                />
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    className="form-control"
                                    defaultValue={props.filter?.DT_INICIO_FN}
                                    type="date"
                                    name="DT_INICIO_FN"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-12 mt-3">
                        <label>Data Fim</label>
                        <div className="row">
                            <div className="col-6">
                                <UnForm.Input
                                    type="date"
                                    defaultValue={
                                        props.filter?.DT_FIM_IN?.split("T")[0]
                                    }
                                    name="DT_FIM_IN"
                                />
                            </div>

                            <div className="col-6">
                                <UnForm.Input
                                    type="date"
                                    defaultValue={
                                        props.filter?.DT_FIM_FN?.split("T")[0]
                                    }
                                    name="DT_FIM_FN"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="text"
                            defaultValue={props.filter?.ID_CASO}
                            name="ID_CASO"
                            label="Protocolo"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label>Status</label>
                        <select
                            className="form-control"
                            name="DS_STATUS_SOLICITACAO"
                            ref={register()}
                            defaultValue={
                                props.filter?.DS_STATUS_SOLICITACAO ?? ""
                            }
                        >
                            <option></option>
                            <option>Aberto</option>
                            <option>Fechado</option>
                            <option>Cancelado</option>
                        </select>
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="text"
                            defaultValue={props.filter?.DS_CONTA}
                            name="DS_CONTA"
                            label="Cliente"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="text"
                            defaultValue={props.filter?.DS_CONTATO}
                            name="DS_CONTATO"
                            label="Contato"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.LazySelect
                            label="Atendente"
                            name="ID_USUARIO_RESPONSAVEL"
                            controller={
                                ListarUsuariosAtivosComAcessoCasoController
                            }
                            getDS={(u) => u.DS_NOME}
                            getKeyValue={(u) => u.ID_USUARIO}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>

                    <div className="col-12 mt-3">
                        <label>Empreendimento</label>
                        <SelectComBusca
                            name="ID_EMPREENDIMENTO"
                            options={options}
                            isMulti={true}
                        />
                    </div>

                    <div className="col-12 mt-3">
                        <label>Etapa</label>
                        <UnForm.Select
                            name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS"
                            defaultValue={
                                props.filter
                                    ?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS
                            }
                        >
                            <option></option>
                            {lstEtapas?.map((etapa) => (
                                <option
                                    value={Number(
                                        etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                    )}
                                >
                                    {
                                        etapa.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                    }
                                </option>
                            ))}
                        </UnForm.Select>
                    </div>
                    <div className={`col-12 mt-3 `}>
                        <UnForm.LazySelect
                            defaultValue={
                                props.filter?.ID_TIPO_CANAL_ATENDIMENTO
                            }
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Canal de Atendimento"
                            name="ID_TIPO_CANAL_ATENDIMENTO"
                            controller={listarCanalAtendimento}
                            getKeyValue={(u) => u.ID_TIPO_CANAL_ATENDIMENTO}
                            getDS={(u) => u.DS_TIPO_CANAL_ATENDIMENTO}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                    {/* <div className={`col-12 mt-3 `}>
                        <label>Não contém</label>
                        <div className="d-flex justify-content-start">
                            <Switch
                                color="success"
                                labelPosition="top"
                                type="checkbox"
                                name="FL_CONTEM"
                                onChange={(e) => {
                                    if (e.target.checked === true) {
                                        Swal.fire({
                                            title: "Ao ativar a opção 'Não Contém', sua pesquisa retornará todos os registros que não têm o texto especificado.",
                                            icon: "info",
                                            buttonsStyling: false,
                                            confirmButtonText:
                                                "<i class='la la-check'></i> Ok!",
                                            customClass: {
                                                confirmButton:
                                                    "btn btn-outline-success",
                                            },
                                        });
                                        props.setNaoContem(false);
                                    } else {
                                        props.setNaoContem(true);
                                    }
                                }}
                                defaultChecked={false}
                                ref={register()}
                            />
                        </div>
                    </div> */}
                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark mt-2"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            onClick={() => {
                                window.sessionStorage.removeItem(
                                    "FILTRO_ATENDIMENTOS_ASSITENCIA_TECNICA"
                                );
                                props.setFilter(props.filtroInicial);
                                reset(props.filtroInicial);
                                onClear();
                            }}
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </StickyToolbar>
    );
}
